<template>
  <form method="get" action @submit.prevent="search">
    <div class="search-wrapper">
      <input
        v-model="query"
        v-autofocus
        type="search"
        autocomplete="off"
        :aria-label="i18n.t('/LeaseCompany/Search/Title')"
        data-qa="search"
      />
      <button class="btn-submit" type="submit" data-qa="search-icon-submit">
        <span class="sr-only">
          {{ i18n.t('/LeaseCompany/Search/Title') }}
        </span>
        <icon class="icon-search" icon="search" />
      </button>
    </div>

    <alert type="info" :text="infoText" />
  </form>
</template>
<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import Alert from '@/components/generic/presentational/atoms/alert/Alert.vue'
import autofocus from '@/mixins/autoFocus.js'

export default {
  components: {
    Icon,
    Alert,
  },
  mixins: [autofocus],
  props: {
    infoText: {
      type: String,
      default: '',
    },
  },
  emits: ['onSearch'],
  data() {
    return {
      query: '',
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  methods: {
    search() {
      this.$emit('onSearch', this.query)
    },
  },
}
</script>

<style lang="scss" scoped>
form {
  margin-bottom: 1em;
}

.search-wrapper {
  position: relative;
  margin-bottom: 0.5em;
}

input[type='search'] {
  width: 100%;
  flex: 1 1 auto;
  padding-right: 3em;
}

.btn-submit {
  $margin: 2px;

  border: 0;
  position: absolute;
  top: $margin;
  right: $margin;
  bottom: $margin;
  display: flex;
  align-items: center;
  background: $gray-lightest;
  padding: 0 0.75em;

  &:hover:not(:disabled) {
    background: $gray-light;
  }

  &[disabled] {
    color: $gray-light;
  }
}

label {
  display: block;
  margin-bottom: 0.5em;
}
</style>
